module.exports = __webpack_public_path__ + "static/redime-tus-puntos-1-e645c873f6f8793f80d95950d37550a1.webp";